module.exports = __webpack_public_path__ + "img/new-missions-and-worlds.a172e9c5.jpg";